import React from 'react';

import { css } from '@emotion/css';
import { Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { TelemonitoringTags } from '@/models/CarePlanModel.ts';
import { PatientListItem } from '@/models/PatientSummaryModel.ts';
import { TelemonitoringActivityTag } from '@/uiKit/molecules/TelemonitoringActivityTag.tsx';

export type TelemonitoringColumnProps = CellContext<
  PatientListItem,
  TelemonitoringTags[]
>;

export const TelemonitoringColumn: React.FC<TelemonitoringColumnProps> = ({
  getValue,
}) => {
  const tagList = getValue();
  const styles = useStyles(makeStyles);

  return (
    <div className={styles.container}>
      <TelemonitoringActivityTag tags={tagList} />
    </div>
  );
};

export const TelemonitoringHeader: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeHeaderStyles);
  return (
    <div className={styles.container}>
      <Typography>{t('pages.patients.telemonitoring')}</Typography>
    </div>
  );
};

const makeStyles = () => ({
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `,
});

const makeHeaderStyles = () => ({
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `,
});
